import axios from '../utils/axios';

export default function getCredInfo(adminId, mgr_id) {
    return (
        axios.get('/admin/' + adminId + `/credits/manager/${mgr_id}/info`)
    )
}